import { render } from "./compareSection.vue?vue&type=template&id=194036b4"
import script from "./compareSection.vue?vue&type=script&lang=js"
export * from "./compareSection.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Admin\\Desktop\\Projects\\maytoni\\vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__